import { useAppContext } from '@/components/utilities/AppContext';

// Fallback labels used when glossary-settings single-type is empty, missing, or
// the fetched locale has only a subset of fields filled in. Keys match the
// GraphQL query in strapi-graphql-glossary-settings-query.js.
const DEFAULT_LABELS = {
  rootLabel: 'Slovník pojmů',
  breadcrumbAriaLabel: 'Drobečková navigace',
  heroEyebrow: 'Slovník pojmů',
  tocTitle: 'Obsah stránky',
  relatedTermsTitle: 'Příbuzné pojmy',
  furtherReadingTitle: 'Další zdroje',
  searchPlaceholder: 'Hledat pojem…',
  searchAriaLabel: 'Hledat pojem',
  filterLabel: 'Filtr:',
  allLabel: 'Vše',
  resultsSingular: 'pojem',
  resultsFew: 'pojmy',
  resultsMany: 'pojmů',
  emptyTitle: 'Žádný pojem nenalezen',
  emptyDescription: 'Zkuste jiný výraz nebo zrušte filtr.',
  termCardReadLabel: 'Přečíst',
  calloutTipLabel: 'Tip:',
  calloutInfoLabel: 'Info:',
  calloutWarningLabel: 'Pozor:',
  calloutSuccessLabel: 'Dobrá zpráva:'
};

const mergeLabels = (settings) => {
  if (!settings) return DEFAULT_LABELS;
  const merged = { ...DEFAULT_LABELS };
  for (const key of Object.keys(DEFAULT_LABELS)) {
    const value = settings[key];
    if (typeof value === 'string' && value.trim() !== '') {
      merged[key] = value;
    }
  }
  return merged;
};

export const useGlossaryLabels = () => {
  const { glossarySettings } = useAppContext();
  return mergeLabels(glossarySettings);
};

export const getGlossaryLabels = (settings) => mergeLabels(settings);
